import type { StackProps } from '@mui/material';

import {
  Section,
  NameBanner,
  CustomizedAccordion,
} from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';
import {
  MainText,
  StyledStack,
  StyledButton,
  DescriptionText,
  StyledTextStack,
  StyledLinkWrapper,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';
import {
  AccordionData,
  StellarProductDevelopmentServicesData,
} from './StellarProductDevelopmentServices.data';

export const StellarProductDevelopmentServices = ({
  ...props
}: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text="Services" color="yellow" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              {StellarProductDevelopmentServicesData.mainText}
            </MainText>
            <DescriptionText variant="strong_400">
              {StellarProductDevelopmentServicesData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion
              data={AccordionData()}
              CustomButton={
                <StyledLinkWrapper>
                  <StyledButton
                    onClick={() => {
                      scrollToElement(contactFormId);
                    }}>
                    Book a free consultation
                  </StyledButton>
                </StyledLinkWrapper>
              }
            />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
